/**
 * @mixin
 */
export default {
    props: {
        /**
         * Enables browser autocompletion.
         */
        allowAutocomplete: {
            type: Boolean,
            default: false
        }
    }
}
